import { JobEntity as BaseJobEntity } from "./JobEntity";
import { JobCompact, JobFeed, JobSearch } from "./JobEntity.presets";
import { JobEntitySkeleton } from "./JobEntity.Skeleton";

type JobEntityWithStatics = typeof BaseJobEntity & {
  Feed: typeof JobFeed;
  Search: typeof JobSearch;
  Compact: typeof JobCompact;
  Skeleton: typeof JobEntitySkeleton;
};

const JobEntity = BaseJobEntity as JobEntityWithStatics;
JobEntity.Feed = JobFeed;
JobEntity.Search = JobSearch;
JobEntity.Compact = JobCompact;
JobEntity.Skeleton = JobEntitySkeleton;

export { JobEntity, JobFeed, JobSearch, JobCompact, JobEntitySkeleton };
export {
  toJobEntityData,
  groupedToJobEntityData,
  jobEntityDataToJob,
} from "./JobEntity.types";
export type {
  JobEntityProps,
  JobEntityData,
  JobEntityActions,
  JobEntityLocation,
} from "./JobEntity.types";
